import { useTheme } from '@repo/theme';
import { Banner } from 'component/banner';
import { Pad } from 'component/basics';
import { InformationalModal } from 'component/modal/informational-modal';
import { Heading, UtilityText } from 'component/text';
import { t } from 'util/stdtypes';

export type HumanModerationModalProps = {
    onClose: () => void;
};

export function HumanModerationModal({ onClose }: HumanModerationModalProps) {
    const { colors } = useTheme();
    return (
        <InformationalModal
            content={
                <Banner color={colors.colorSurfaceBannerInfo}>
                    <Heading color={colors.colorTextPrimary} label={t('moderation.what_happens_next', '📫 What happens next')} />
                    <Pad size={16} />
                    <UtilityText
                        color={colors.colorTextPrimary}
                        label={t(
                            'moderation.email_notification',
                            'You will receive an email notification when your post is approved or rejected by moderators.',
                        )}
                    />
                </Banner>
            }
            headingLabel={t('moderation.thank_you', 'Thank you!')}
            onClose={onClose}
            subheadingLabel={t('moderation.sent_to_moderator', 'Your response has been sent to a moderator for review.')}
        />
    );
}
